export enum TipoNotificacaoEnum {
  ANDAMENTO_SOLICITACAO = 'andamento_solicitacao',
  NOVA_SOLICITACAO = 'nova_solicitacao',
  ADMINISTRATIVA = 'administrativa',
  ALERTA_SISTEMA = 'alerta_sistema'
}
